import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import perdasHeaderLocalizacaoReport from "./PerdasHeaderLocalizacaoReport";

import TableReportHelper from "report/helper";

export default async function perdasReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)

        content.push([
            await perdasHeaderLocalizacaoReport(visita, indicador, apontamento, params, "", indicador.type),
            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),
            h.space(),
        ]);
    }

    return content;
}
